import styles from './BannerText.scss';

import { ReferencedEntry } from 'contentful';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { BrandingBanner, SalesChannelPromotion } from 'src/api/contentful/contentTypes.shop';
import { Blurb, IBlurb } from 'src/components/Contentful/Blurb';
import { IMarkdownWrapperProps } from 'src/components/MarkdownWrapper/MarkdownWrapper';
import { DetailedPromotion } from 'src/components/ProgramPromotion/UseProgramPromotion';
import { getField } from 'src/utils/EntryUtil';
import { isTypeByKey } from 'src/utils/Object';

export const PromotionHighlight: React.FC = props => <span className={styles.promotionHighlightText} {...props} />;

type BlurbProps = Partial<Omit<IBlurb<any>, 'entry' | 'field'> & IMarkdownWrapperProps<any>> & { children?: never };

type Promotion = DetailedPromotion | ReferencedEntry<SalesChannelPromotion>;

type BannerTextProps = BlurbProps & {
  brandingBanner?: ReferencedEntry<BrandingBanner>;
  currentPromotion?: Promotion;
};

export const PromoBannerText: React.FC<BlurbProps & { currentPromotion: Promotion }> = ({ currentPromotion, templateData, renderers, ...props }) => {
  const { t } = useTranslation();

  return isTypeByKey<DetailedPromotion>(currentPromotion, 'promotionLongDescription') ?
    <h3 data-test="partner-banner-description">{currentPromotion.promotionLongDescription}</h3>
  : (
    <Blurb
      entry={currentPromotion}
      field="bannerText"
      templateData={{
        ...templateData,
        price: t('product-price', {
          price: getField(getField(currentPromotion, 'promoPricing'), 'price'),
        }),
      }}
      renderers={{
        ...renderers,
        inlineCode: PromotionHighlight,
      }}
      {...props}
    />
    );
};

export const BannerText: React.FC<BannerTextProps> = ({ brandingBanner, currentPromotion, ...props }) =>
  currentPromotion ? <PromoBannerText currentPromotion={currentPromotion} {...props} /> : <Blurb entry={brandingBanner} data-test="partner-banner-description" field="descriptionBlurb" {...props} />;
